// import { _insuranceProviderInputGroup } from "common/ObjectSchema";
// import { calendarFormat } from "moment";

var COLORS = {
    LIGHTBLUE: "#00AEEF",
    WHITE: "#ffffff",
    GREY: "#dedede",
	TRANSPARENT_LIGHTBLUE: "rgba(0, 174, 239, 0.4)" // 00AEEF
};

var SERIES = {
	CONTACT: { index:0, label:'Contact' },
	TILT: { index:1, label:'Tilt' },
	ROTATION: { index:2, label:'Rotation' },
	DISTANCE: { index:3, label:'Distance' }
	
};

// Private:
var chart = {};

// Exported for use from React code

export function _init(chartCanvasName, fontSize){
	init(chartCanvasName, fontSize);
}

// eslint-disable-next-line no-unused-vars
export function _setDistance(chartCanvasName, value) {
	setDistance(chartCanvasName, value);
}

// eslint-disable-next-line no-unused-vars
export function _setContact(chartCanvasName, value) {
	setContact(chartCanvasName, value);
}

// eslint-disable-next-line no-unused-vars
export function _setTilt(chartCanvasName, value) {
	setTilt(chartCanvasName, value);
}

// eslint-disable-next-line no-unused-vars
export function _setRotation(chartCanvasName, value) {
	setRotation(chartCanvasName, value);
}

// eslint-disable-next-line no-unused-vars
export function _clearChart(chartCanvasName){
	clear(chartCanvasName);
}

// Public:

// eslint-disable-next-line no-unused-vars
function init(chartCanvasName, fontSize) {
	
	//console.log(`init(${fontSize})`);

	if ((undefined === fontSize) || (null === fontSize)) {
			fontSize = 18;
	}

	var canvas = undefined;

	if (typeof chartCanvasName === 'string' || chartCanvasName instanceof String) {
		canvas = document.getElementById(chartCanvasName);
	}

	if ((undefined === canvas) || (null === canvas)) {
		console.log('init canvas NOT INITIALISED', canvas);
		return;
	}
	
	// eslint-disable-next-line no-undef
	Chart.defaults.global.defaultFontFamily = 'Montserrat';
	// eslint-disable-next-line no-undef
	Chart.defaults.global.defaultFontColor = COLORS.WHITE;

    var labels = [
		SERIES.CONTACT.label,
		SERIES.TILT.label,
		SERIES.ROTATION.label,
		SERIES.DISTANCE.label
	];
		
	var dataset = {
		backgroundColor: COLORS.TRANSPARENT_LIGHTBLUE,
		borderColor: COLORS.TRANSPARENT_LIGHTBLUE,
		pointRadius: 0,
		data: [],
		borderWidth: 0
	};
		
	var data = {
		labels: labels,
		datasets: [ dataset ]
	};
		
	var options = {
		responsive: true,
		startAngle: 45,
		maintainAspectRatio: true,
		spanGaps: true,
		elements: {
			line: {
				tension: 0.000001 // 0.4 would make the lines smooth
			}
		},
		legend: {
			display: false
		},
		animation: {
			animateScale: true,
			animateRotate: true
		},
		scale: {
			gridLines: {
				lineWidth: [
					1,
					1,
					1,
					2
				],
				color: [
					COLORS.GREY,
					COLORS.GREY,
					COLORS.GREY,
					COLORS.LIGHTBLUE
				],
				drawBorder: false,
				circular: false
			},
			angleLines: {
				display: true,
				color: COLORS.GREY
			},
			ticks: {
				min: 0,
				max: 100,
				stepSize: 25,
				
				// bit of a hack; drawPointLabels puts padding in for the first label, which isn't needed in a radar chart. So set these so that getTickBackdropHeight returns 0
				fontSize: 0,
				backdropPaddingY: 0, 
				
				callback: function () {
					return '';
				},
				showLabelBackdrop: false,
				beginAtZero: true
			},
			pointLabels: {
				fontFamily: 'Montserrat', // todo can we load this from the file on disk?
				fontSize: fontSize,
				fontStyle: 'bold',
				callback: function (label) {
					var i;
					for (i = 0; i < labels.length; i++) {
						if (labels[i] === label) {
							var v = dataset.data[i];
							if (undefined !== v) {
								v = v.toFixed(1).replace('.0','');
							}
							return [ label, `${v}%` ];
						}
					}
					return label;
				},
				fontColor: COLORS.WHITE,
				display: true
			},
			display: true
		}
	};

	 // Only create the chart object once
	 if (chart[chartCanvasName] === null || chart[chartCanvasName] === undefined) {
        // eslint-disable-next-line no-undef
        chart[chartCanvasName] = new Chart(canvas, {
            type: 'radar',
            data: data,
            options: options
        });
    } else {
        chart[chartCanvasName].data = data;
        chart[chartCanvasName].options = options;
        chart[chartCanvasName].update();
    }
}

function clear(chartCanvasName){
    if (chart[chartCanvasName] !== null && chart[chartCanvasName] !== undefined) {
        chart[chartCanvasName].clear();
        chart[chartCanvasName] = null;
    }
}

// eslint-disable-next-line no-unused-vars
function setDistance(chartCanvasName, value) {
    chart[chartCanvasName].data.datasets[0].data[SERIES.DISTANCE.index] = value;
    chart[chartCanvasName].update();
}

// eslint-disable-next-line no-unused-vars
function setContact(chartCanvasName, value) {
    chart[chartCanvasName].data.datasets[0].data[SERIES.CONTACT.index] = value;
    chart[chartCanvasName].update();
}

// eslint-disable-next-line no-unused-vars
function setTilt(chartCanvasName, value) {
    chart[chartCanvasName].data.datasets[0].data[SERIES.TILT.index] = value;
    chart[chartCanvasName].update();
}

// eslint-disable-next-line no-unused-vars
function setRotation(chartCanvasName, value) {
    chart[chartCanvasName].data.datasets[0].data[SERIES.ROTATION.index] = value;
    chart[chartCanvasName].update();
}
